import React from 'react'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'
import logoSrc from 'view/styles/images/brokerTecLogo.svg'
import { LoaderAnimation } from 'view/components/loader/Loader'

interface LoginBackgroundProps {
  showSpinner?: boolean
  children?: React.ReactNode
}

const LoginContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: ${constants.zIndexConnectionOverlay};
  background-color: ${constants.CORE_PRIMARY_6};
  background-image: url(${logoSrc});
  background-size: 300px auto;
  background-position: center 170px;
`
const SpinnerContainer = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${constants.CORE_PRIMARY};
`

export const LoginBackground: React.FunctionComponent<LoginBackgroundProps> = props => {
  return (
    <LoginContainer>
      {props.showSpinner && (
        <SpinnerContainer data-test-id="Login-Loading" tabIndex={0}>
          <LoaderAnimation />
        </SpinnerContainer>
      )}
      {props.children}
    </LoginContainer>
  )
}
